module.exports = __webpack_public_path__ + "/build/web/images/hero-training@3x.35b09294ba1e86d9e3f15017ae87de8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-training@3x.jpg
// module id = 153
// module chunks = 13